import './helpers'
import './axios'
import './fontawesome'
import './bootstrap-vue'
import 'popper.js'
import 'bootstrap'

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
  window.$ = window.jQuery = require('jquery')
  require('popper.js')
  require('bootstrap')
} catch (e) {}



// WEBPACK FOOTER //
// ./resources/js/plugins/index.js